import { ObjectListRequestType } from '../ObjectListResponseTypes'

export interface CommissionItem {
  relationId: number
  year: number
  month: number
  amount: number
}

export interface CommissionData {
  total: number
  page: number
  pageSize: number
  commissions: CommissionItem[]
}

interface CommissionResponse {
  data: CommissionData
  meta: null | any
}

interface CommissionRequestBody extends ObjectListRequestType {}

interface CommissionListResponse {
  data: CommissionData
  meta: null | Record<string, any>
}

const isCommissionListResponse = (commission: any): commission is CommissionListResponse => {
  if (commission === null || commission === undefined) {
    return false
  }
  return Boolean(commission.data && Array.isArray(commission.data.commissions))
}

export type { CommissionResponse, CommissionRequestBody }
export { isCommissionListResponse }
